import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context";

const ProjectWindow = ({ project }) => {
  const { goToTop } = useGlobalContext();
  const maxLength = 60; // set the maximum length of the description here

  // function to truncate the description and add ellipses
  const truncateDesc = (desc) => {
    if (desc.length > maxLength) {
      return desc.slice(0, maxLength) + "...";
    } else {
      return desc;
    }
  };

  return (
    <>
      <Link
        to={`/projects/${project.id}`}
        className="projectWindowAnchor fadeUp"
        onClick={() => goToTop("projects")}
      >
        <div className="projectWindowContainer">
          <img
            src={project.images[0]}
            className="projectWindowImage"
            alt={`project-${project.id}`}
          />
          <div className="projectWindowTitle">{project.title}</div>
          <div className="projectWindowDesc">
            {truncateDesc(project.short_desc)}
          </div>{" "}
        </div>
      </Link>
    </>
  );
};

export default ProjectWindow;
